import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const breadcrumbItems = items.map((item, index) => ({
    ...item,
    "@type": "ListItem" as const,
    position: index + 1,
  }));

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbItems.map((item) => ({
      "@type": "ListItem",
      position: item.position,
      name: item.label,
      item: item.to
        ? `https://meinvgaoji.com${item.to}`
        : "https://meinvgaoji.com",
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="py-3">
        <ol className="flex items-center flex-wrap gap-1 text-sm">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;
            return (
              <li key={index} className="flex items-center gap-1">
                {index > 0 && (
                  <span className="text-foreground-400 mx-1">/</span>
                )}
                {isLast || !item.to ? (
                  <span className="text-foreground-600">{item.label}</span>
                ) : (
                  <Link
                    to={item.to}
                    className="text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {item.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    </>
  );
}